import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { SkillsCollection } from './skills.types';

export function skillsBackend(): Backend<SkillsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => {
      return {
        endpoint: 'projects/0.1/jobs/',
        params: {
          active_project_count_details: true,
          job_names: getQueryParamValue(query, 'name'),
          only_local: getQueryParamValue(query, 'local')[0],
          jobs: ids,
          lang: query?.searchQueryParams.languageCode,
          question_context_type: query?.searchQueryParams.questionContextType,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
